import { render, staticRenderFns } from "./WelcomePageBAdmin.vue?vue&type=template&id=3ed4c012&scoped=true"
import script from "./WelcomePageBAdmin.vue?vue&type=script&lang=js"
export * from "./WelcomePageBAdmin.vue?vue&type=script&lang=js"
import style0 from "./WelcomePageBAdmin.vue?vue&type=style&index=0&id=3ed4c012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4c012",
  null
  
)

export default component.exports